<template>
  <div id="assets-control">
    <div class="sticky-wrapper">
      <h2 class="assets-title">Assets</h2>
      <AssetsItem v-if="getImageAssets.length" title="Image" :build-assets="getImageAssets" />
      <AssetsItem v-if="getSpinAssets.length" title="Spin" :build-assets="getSpinAssets" />
      <AssetsItem v-if="getVideoAssets.length" title="Video" :build-assets="getVideoAssets" />
      <AssetsItem v-if="getViewAssets.length" title="View" :build-assets="getViewAssets" />
      <AssetsItem v-if="getModelAssets.length" title="Model" :build-assets="getModelAssets" />
      <AssetsItem
        v-if="getPanoramaAssets.length"
        title="Panorama"
        :build-assets="getPanoramaAssets"
      />

      <div class="assets-add">
        <h3 class="assets-add__title">Use your own</h3>
        <div class="assets-add__plus" @click="handlerAssetsForm">
          <img src="https://sirv.sirv.com/website/theme2/icon/plus.svg" alt="Use your own" />
        </div>
      </div>
      <div class="assets-add">
        <div class="assets-add__btn" :disabled="locked" @click="handlerAssetsReset">Reset</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import AssetsItem from "@/widgets/common/AssetsItem";
import itemErrors from "@/store/observable/item-errors";
import collapseParent from "@/store/observable/option-elements-parent";
import collapseCSS from "@/store/observable/option-elements-css";
import collapseJS, { collapseJSReactive } from "@/store/observable/option-elements-js";

export default {
  name: "AssetsControl",
  components: {
    AssetsItem,
  },
  data() {
    return {
      locked: false,
    };
  },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters([
      "getImageAssets",
      "getSpinAssets",
      "getVideoAssets",
      "getViewAssets",
      "getModelAssets",
      "getPanoramaAssets",
      "itemErrors",
    ]),
    collapseParent,
    collapseCSS,
    collapseJS,
  },
  created() {
    window.onpopstate = function (event) {
      if (event.state !== null) {
        console.log(event.state);
        window.history.pushState(event.state, document.title, document.location);
        window.location.reload();
      }
    };
  },
  methods: {
    handlerAssetsForm() {
      this.$store.dispatch("showAssetsForm", true);
    },
    async handlerAssetsReset() {
      this.locked = true;
      const configUrl = this.$route.query?.config ? this.$route.query.config : null;
      await this.$store.dispatch("changeViewSMVMode", false);
      await this.$store.dispatch("changeClearOptions", false);
      await this.$store.dispatch("changeClearOptionsCSS", false);
      await this.$store.dispatch("changeClearOptionsJS", false);
      if (!configUrl) await itemErrors.clear();

      await this.$store.dispatch("resetConfigUrl");
      window.history.pushState({}, document.title, this.$route.path);
      this.collapseParent = 0;
      this.collapseCSS = 0;
      this.collapseJS = 0;
      await setTimeout(() => {
        const query = Object.keys(this.$route.query).length !== 0 ? null : null;
        this.$store.dispatch("changeExample", { type: "default", query });
        this.locked = false;
      }, 200);
      await setTimeout(() => {
        this.$store.dispatch("enableZoom", true);
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
.sticky-wrapper {
  top: 90px;
  position: sticky;
}
#assets-control {
  box-shadow: 0 8px 40px rgba(50, 123, 186, 0.16), 0 4px 4px rgba(50, 123, 186, 0.08);
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  width: 100%;

  @media only screen and (min-width: 992px) {
    margin-bottom: 0;
    flex: 0 0 140px;
  }
}

.assets-add {
  &__title {
    font-size: 1.17em;
    font-weight: bold;
    color: #6c7683;
    text-align: center;
  }
  &__btn {
    width: 100%;
    background-color: #fff;
    border-radius: 4px;
    color: #327bba;
    margin-bottom: 10px;
    padding: 6px 0;
    text-align: center;
    border: 1px solid #327bba;
    cursor: pointer;
    transition: background-color 0.5s ease, color 0.5s ease;
    &:hover {
      background-color: #327bba;
      color: #fff;
    }
  }
  &__plus {
    margin-bottom: 10px;
    cursor: pointer;
    width: 100%;
    min-height: 60px;
    display: flex;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    border: 1px solid #327bba;
    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
  img {
    width: 30px;
    height: 30px;
    transition: transform 0.5s ease;
  }
}
</style>
